/*
 * Authors: Koen, mariushirjanu
 * Created: 17/11/2018
 * Upgraded: 20/10/2022
 */

import { Component, Input, ViewEncapsulation } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { UntypedFormGroup } from '@angular/forms';
import { BodyClassService } from '../../../shared/services/body-class.service';
import { UserProfileWrapperComponent } from '../../userprofile/user-profile-wrapper.component';

@Component({
  selector: 'user-profile-demo',
  template: `
    <h1>User profile modal dialog</h1>
    <div class="row">
      <div class="col-md-6">
        <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
        <button class="btn btn-primary" (click)="openDialog()">Open user profile dialog</button>
      </div>
    </div>
  `,
  styleUrls: ['./user-profile-demo.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserProfileDemoComponent {
  @Input() public userId:number;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:{
    userId:string;
  } = {
    userId: 'NEW'
  };

  constructor(
    private bodyClassService:BodyClassService,
    private formlyService:GaFormlyService,
    private messageService:GaMessageService
  ) {
    this.bodyClassService.add('user-profile-demo');
    this.createFields();
  }

  private createFields() {
    this.fields = [
      this.formlyService.anInput('userId', 'User ID')
        .build()
    ];
  }

  public openDialog():void {
    const closeDialog:Function = () => {
      dialog.hide();
    };

    const dialog:IDialog = this.messageService.showDialog({
      component: UserProfileWrapperComponent,
      wrapperComponent: false,
      inputs: {
        userId: this.model.userId,
        showCancelButton: false
      },
      outputs: {
        onSaved: closeDialog,
        onCancel: closeDialog
      },
      size: DialogSize.XL,
      closeButton: true
    });
  }
}